export default __webpack_public_path__ + "0368b8695e1846de661c04bc86dfcd61.png";